import { UserHeader } from 'components/headers';
import { Icon, IconName } from 'libs/icons';

import { UserProfileWithStructure } from '../types';

interface IUserCellRendererProps {
  readonly user: UserProfileWithStructure;
  readonly onUserClick?: () => void;
  readonly iconName?: IconName;
}

export function UserCellRenderer({
  user,
  onUserClick,
  iconName = IconName.ChevronDown
}: IUserCellRendererProps) {
  const content = (
    <>
      <UserHeader
        user={user}
        showQualification={false}
        showCheckAssurance={false}
        showBadges={false}
        showCountryFlag
        disableNavigation
        showNewRegistration
      />

      {iconName && <Icon name={iconName} className="text-primary" size={16} />}
    </>
  );

  if (onUserClick) {
    return (
      <button
        onClick={() => onUserClick()}
        className="flex justify-between items-center gap-2 w-full"
      >
        {content}
      </button>
    );
  }

  return (
    <div className="flex justify-between items-center gap-2 w-full">
      {content}
    </div>
  );
}
